import { render, staticRenderFns } from "./SaveRoleButton.vue?vue&type=template&id=42a9333a&scoped=true&"
import script from "./SaveRoleButton.vue?vue&type=script&lang=js&"
export * from "./SaveRoleButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a9333a",
  null
  
)

export default component.exports